<template>
  <FormulateInput
    type="text"
    :label="label"
    v-model="input_value"
    onchange="onChangeInput"
    :input-class="disabled ? 'disabled' : 'editMode'"
    :disabled="disabled"
  />
</template>

<script>
export default {
  name: "InputString",
  props: ["label", "value", "options", "name", "disabled"],
  data() {
    return {
      input_value: this.value
    };
  },
  watch: {
    input_value(value) {
      this.$emit("FlexpropDataChange", { key: this.name, value: value });
    }
  }
};
</script>
